const EXCEL_TYPES = new Set([
	'application/vnd.ms-excel',
	'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
	'application/vnd.openxmlformats-officedocument.spreadsheetml.template',
	'application/vnd.ms-excel.sheet.macroEnabled.12',
	'application/vnd.ms-excel.template.macroEnabled.12',
	'application/vnd.ms-excel.addin.macroEnabled.12',
	'application/vnd.ms-excel.sheet.binary.macroEnabled.12',
]);

const SLIDE_TYPES = new Set([
	'application/vnd.ms-powerpoint',
	'application/vnd.openxmlformats-officedocument.presentationml.presentation',
	'application/vnd.openxmlformats-officedocument.presentationml.template',
	'application/vnd.openxmlformats-officedocument.presentationml.slideshow',
	'application/vnd.openxmlformats-officedocument.presentationml.slideshow',
	'application/vnd.ms-powerpoint.presentation.macroEnabled.12',
	'application/vnd.ms-powerpoint.template.macroEnabled.12',
	'application/vnd.ms-powerpoint.slideshow.macroEnabled.12',
]);

const DOCUMENT_TYPES = new Set([
	'application/msword',
	'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
	'application/vnd.openxmlformats-officedocument.wordprocessingml.template',
	'application/vnd.ms-word.document.macroEnabled.12',
	'application/vnd.ms-word.template.macroEnabled.12',
	'application/vnd.oasis.opendocument.text',
]);

const VIDEO_TYPES = new Set(['application/quicktime', 'video/mp4', 'video/quicktime']);

const document_extensions = new Set(['doc', 'dot', 'docx', 'dotx', 'docm', 'dotm', 'odt', 'txt']);
const excel_extensions = new Set(['xls', 'xlt', 'xla', 'xlsx', 'xltx', 'xlsm', 'xltm', 'xlam', 'xlsb']);
const slide_extensions = new Set(['ppt', 'pot', 'pps', 'ppa', 'pptx', 'potx', 'ppsx', 'ppam', 'pptm', 'potm', 'ppsm']);
const pdf_viewable_extensions = new Set(['pdf', 'jpg', 'png', 'jpeg']);
const video_viewable_extensions = new Set(['mp4', 'MOV', 'mov']);

const PDF_TYPES = new Set(['application/pdf']);

export const isImage = contentType => contentType.includes('image/');
export const isVideo = contentType => VIDEO_TYPES.has(contentType);
export const isPDF = contentType => PDF_TYPES.has(contentType);
export const isSPREADSHEET = (contentType, ext) => EXCEL_TYPES.has(contentType) || excel_extensions.has(ext);
export const isPRES = (contentType, ext) => SLIDE_TYPES.has(contentType) || slide_extensions.has(ext);
export const isDOC = (contentType, ext) => DOCUMENT_TYPES.has(contentType) || document_extensions.has(ext);
export const canPreview = ext => pdf_viewable_extensions.has(ext) || video_viewable_extensions.has(ext);
export const canPdfPreview = ext => pdf_viewable_extensions.has(ext);
export const canVideoPreview = ext => video_viewable_extensions.has(ext);
